var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signature" }, [
    _c("div", { staticClass: "canvas-wrapper" }, [
      _c("canvas", {
        ref: "canvasEl",
        staticClass: "canvas-el",
        attrs: { height: "614", width: "1328" },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "canvas-footer" }, [
      _c("div", { staticClass: "canvas-footer-top" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("\n        Please Sign Above\n      "),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-clear btn-sm btn-default",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.clear($event)
              },
            },
          },
          [_vm._v("\n        Clear\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "canvas-footer-bottom" }, [
        _vm._v(
          "\n      By signing above you agree to allow " +
            _vm._s(_vm.venue.name) +
            " to capture and retain your contact & purchase information in order to provide you with a more personalized marketing and communications experience.\n      In addition, by providing your mobile number and signing above, you consent to receive marketing focused text messages at the number provided via an automatic text message delivery system and/or artificial/pre-recorded messages from " +
            _vm._s(_vm.venue.name) +
            ".\n      Consent is not required as a condition of purchasing any goods or services. Standard per minute call and message rates may apply.\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/Signature/template.html?vue&type=template&id=d354dd8a&
// module id = 1078
// module chunks = 0